import { Component } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'date-picker-accessibility',
  templateUrl: './date-picker-accessibility.component.html',
  styleUrls: ['./date-picker-accessibility.component.sass']
})
export class DatePickerAccessibilityComponent {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }
}
